// extracted by mini-css-extract-plugin
export default {"text-color-light":"#707070","textColorLight":"#707070","from":"_2MBcX _1D3zw _1Zmlx"};